import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportPDFController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportPDFController.php
* @route '/api/invoice/export-pdf'
*/
const AccountingExportPDFController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: AccountingExportPDFController.url(options),
    method: 'get',
})

AccountingExportPDFController.definition = {
    methods: ["get","head"],
    url: '/api/invoice/export-pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportPDFController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportPDFController.php
* @route '/api/invoice/export-pdf'
*/
AccountingExportPDFController.url = (options?: RouteQueryOptions) => {
    return AccountingExportPDFController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportPDFController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportPDFController.php
* @route '/api/invoice/export-pdf'
*/
AccountingExportPDFController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: AccountingExportPDFController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceExport\AccountingExportPDFController::__invoke
* @see app/Http/Controllers/InvoiceExport/AccountingExportPDFController.php
* @route '/api/invoice/export-pdf'
*/
AccountingExportPDFController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: AccountingExportPDFController.url(options),
    method: 'head',
})

export default AccountingExportPDFController